const siteUrl =
	import.meta.env.VITE_SITE_URL ||
	import.meta.env.VITE_BETTER_AUTH_URL ||
	"http://localhost:3000";

export function getLocalizedSeoUrls(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return {
		canonicalUrl: `${siteUrl}${_opts.internalPath}`,
	};
}

export function ogImageUrl(slug = "default"): string {
	return `${siteUrl}/og/${slug}.png`;
}

export function dynamicAgentOgUrl(
	agentSlug: string,
	version?: string | number,
): string {
	const query =
		version != null ? `?v=${encodeURIComponent(String(version))}` : "";
	return `${siteUrl}/api/og/agents/${agentSlug}${query}`;
}

export function dynamicFounderOgUrl(
	founderSlug: string,
	version?: string | number,
): string {
	const query =
		version != null ? `?v=${encodeURIComponent(String(version))}` : "";
	return `${siteUrl}/api/og/founders/${founderSlug}${query}`;
}

export function buildLocalizedSeoLinks(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return [{ rel: "canonical", href: `${siteUrl}${_opts.internalPath}` }];
}
